import init from './thing'

const activity =
{
    ...init
};

export default activity ;
